import { useState } from 'react';

const clients = [
  { name: 'Randoncorp', abbr: 'RC', sector: 'Veículos & Implementos Rodoviários', domain: 'randoncorp.com.br', customLogo: 'https://storage.readdy-site.link/project_files/55d2414d-b0d8-48ff-97d2-b36c2fb1f46c/d71bf8f3-5143-4498-b53c-2b1b71c948e4_RANDONCORP.png?v=fae025684ea8f3fdaccb4da61d4d114a' },
  { name: 'Fremax', abbr: 'FM', sector: 'Freios Automotivos', domain: 'fremax.com.br', customLogo: 'https://storage.readdy-site.link/project_files/55d2414d-b0d8-48ff-97d2-b36c2fb1f46c/0c69fef8-7814-4bb1-867f-6ffe72949d06_transferir-4.jpg?v=934e10b1d64930f37c7bc065baef312a' },
  { name: 'Controil', abbr: 'CI', sector: 'Filtros & Motores', domain: 'controil.com.br', customLogo: 'https://storage.readdy-site.link/project_files/55d2414d-b0d8-48ff-97d2-b36c2fb1f46c/ffb32ccd-8c83-43a4-90ca-61f0229de717_controil.png?v=c3d1a1e68970c21b6a03f57f828e86f0' },
  { name: 'Master Freios', abbr: 'MF', sector: 'Sistemas de Freios', domain: 'masterfreios.com.br', customLogo: 'https://storage.readdy-site.link/project_files/55d2414d-b0d8-48ff-97d2-b36c2fb1f46c/571954ce-fdb4-40d4-aa78-0ba16ce899f5_MASTER.png?v=e822a6ea5a58fdfdd859d6fb73bbd0cd' },
  { name: 'Jost', abbr: 'JO', sector: 'Componentes Automotivos', domain: 'jostbrasil.com.br', customLogo: 'https://storage.readdy-site.link/project_files/55d2414d-b0d8-48ff-97d2-b36c2fb1f46c/00bdfdcf-269f-441b-935e-e643e0107888_transferir.png?v=a9c2088136669308e16918f17b64b334' },
  { name: 'Suspensys', abbr: 'SY', sector: 'Suspensões Veiculares', domain: 'suspensys.com.br', customLogo: 'https://storage.readdy-site.link/project_files/55d2414d-b0d8-48ff-97d2-b36c2fb1f46c/f02a291b-ea86-4132-83f3-b5eee9e6059a_SUSPENSYS.png?v=e3d5df51feb76de1ddf5e8c2024eaea0' },
  { name: 'Castertech', abbr: 'CT', sector: 'Tecnologia Automotiva', domain: 'castertech.com.br', customLogo: 'https://storage.readdy-site.link/project_files/55d2414d-b0d8-48ff-97d2-b36c2fb1f46c/4ade2b3a-8c0d-47b0-bb22-06618a919abe_CASTER.png?v=474d4185d29ba522e86a299daf53c297' },
  { name: 'Frasle', abbr: 'FR', sector: 'Fricção & Componentes Automotivos', domain: 'frasle.com.br', customLogo: 'https://storage.readdy-site.link/project_files/55d2414d-b0d8-48ff-97d2-b36c2fb1f46c/9f2d4d09-e2c3-417f-9773-3f45919b6757_FRASLE.png?v=acceffd44cbf338145f9187a4968c8a3' },
  { name: 'Keko Acessórios', abbr: 'KA', sector: 'Acessórios Veiculares', domain: 'keko.com.br', customLogo: 'https://storage.readdy-site.link/project_files/55d2414d-b0d8-48ff-97d2-b36c2fb1f46c/3efcc665-0724-4abc-8493-f5950c681244_transferir-3.jpg?v=cf140c8eee403cd2a3937ff1d04490d2' },
  { name: 'Protesul Segurança', abbr: 'PV', sector: 'Vigilância & Segurança', domain: 'protesul.com.br', customLogo: 'https://storage.readdy-site.link/project_files/55d2414d-b0d8-48ff-97d2-b36c2fb1f46c/3a6cb2f3-1c42-4b59-80fe-8cb67513b7e7_transferir-2.jpg?v=cc56b6cf62ff15fd13042ca078951df2' },
  { name: 'Scain Metalúrgica', abbr: 'SM', sector: 'Metalurgia Industrial', domain: 'scain.com.br', customLogo: 'https://storage.readdy-site.link/project_files/55d2414d-b0d8-48ff-97d2-b36c2fb1f46c/34ab10ea-a350-4324-ae5c-4a7503be7620_metalurgica_scain_logo.jpg?v=4e52a039216989e55009bc9bfb0cbc4c' },
  { name: 'NL Informática', abbr: 'NL', sector: 'Tecnologia da Informação', domain: 'nlinformatica.com.br', customLogo: 'https://storage.readdy-site.link/project_files/55d2414d-b0d8-48ff-97d2-b36c2fb1f46c/233b767e-4a64-4765-b5e1-d524d87ad7cd_logo-nl-site-2025-3.png?v=a6d569dea56871818b17e99f0cdd2127' },
];

function ClientCard({ client }: { client: typeof clients[0] }) {
  const [imgError, setImgError] = useState(false);
  const logoUrl = client.customLogo || `https://logo.clearbit.com/${client.domain}`;

  return (
    <div className="border border-neutral-200 rounded-2xl p-6 flex flex-col items-center text-center hover:border-red-300 hover:bg-red-50/30 transition-all group cursor-default">
      <div className="w-20 h-14 flex items-center justify-center mb-4">
        {!imgError ? (
          <img
            src={logoUrl}
            alt={`Logo ${client.name}`}
            onError={() => setImgError(true)}
            className="max-w-full max-h-full object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
          />
        ) : (
          <div className="w-14 h-14 flex items-center justify-center bg-neutral-100 group-hover:bg-red-100 rounded-full transition-colors">
            <span className="text-base font-bold text-neutral-600 group-hover:text-red-600 transition-colors">
              {client.abbr}
            </span>
          </div>
        )}
      </div>
      <p className="font-semibold text-neutral-800 text-sm leading-tight">{client.name}</p>
      <p className="text-neutral-400 text-xs mt-1.5">{client.sector}</p>
    </div>
  );
}

export default function Clients() {
  return (
    <section id="clients" className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="max-w-2xl mx-auto text-center mb-16">
          <span className="inline-block text-red-600 text-xs font-bold uppercase tracking-widest bg-red-50 px-3 py-1.5 rounded-full mb-6">
            / Nossos Clientes
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-neutral-900 mb-5 leading-tight" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Empresas que{' '}
            <span className="text-red-600">Confiam</span>{' '}
            na RE_CONECTA
          </h2>
          <p className="text-neutral-500 text-base leading-relaxed">
            Atendemos empresas de renome nacional em diferentes setores industriais, entregando
            segurança, confiabilidade e resultados de alto padrão.
          </p>
        </div>

        {/* Clients Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {clients.map((client) => (
            <ClientCard key={client.name} client={client} />
          ))}

          {/* CTA Card */}
          <div className="border-2 border-dashed border-neutral-200 rounded-2xl p-6 flex flex-col items-center justify-center text-center hover:border-red-200 transition-colors group cursor-default">
            <div className="w-11 h-11 flex items-center justify-center mb-3">
              <i className="ri-add-circle-line text-3xl text-neutral-300 group-hover:text-red-400 transition-colors"></i>
            </div>
            <p className="text-neutral-400 text-sm font-medium">Sua empresa<br />pode ser a próxima</p>
          </div>
        </div>

        {/* Trust Bar */}
        <div className="mt-14 bg-neutral-950 rounded-2xl p-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center bg-red-600 rounded-xl">
              <i className="ri-shield-star-line text-white text-2xl"></i>
            </div>
            <div>
              <p className="text-white font-bold text-lg" style={{ fontFamily: 'Poppins, sans-serif' }}>Segurança de nível industrial</p>
              <p className="text-neutral-400 text-sm">para empresas de todos os portes</p>
            </div>
          </div>
          <div className="flex items-center gap-8">
            {[
              { label: 'Projetos', value: '100+' },
              { label: 'Uptime', value: '99.9%' },
              { label: 'Satisfação', value: '100%' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <p className="text-white font-bold text-2xl" style={{ fontFamily: 'Poppins, sans-serif' }}>{stat.value}</p>
                <p className="text-neutral-500 text-xs mt-0.5">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
